import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import {
  ChatExplorer,
  ChatExport,
  Dashboard,
  EmailCapture,
  Login,
  Settings,
  Sources,
  Users,
  WhatsappBulkSend,
  WhatsappCampaigns,
} from './pages';
import HomeRedirect from './components/HomeRedirect';
import ProtectedRoute from './components/ProtectedRoute';
import {
  ROLES_WITH_DASHBOARD_ACCESS,
  ROLES_WITH_WHATSAPP_ACCESS,
  SUPERADMIN_ONLY_ROLES,
} from './constants/roles';

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={ROLES_WITH_DASHBOARD_ACCESS}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat-explorer"
          element={
            <ProtectedRoute allowedRoles={ROLES_WITH_DASHBOARD_ACCESS}>
              <ChatExplorer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chat-export"
          element={
            <ProtectedRoute allowedRoles={ROLES_WITH_DASHBOARD_ACCESS}>
              <ChatExport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute allowedRoles={SUPERADMIN_ONLY_ROLES}>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sources"
          element={
            <ProtectedRoute allowedRoles={SUPERADMIN_ONLY_ROLES}>
              <Sources />
            </ProtectedRoute>
          }
        />
        <Route
          path="/email-capture"
          element={
            <ProtectedRoute allowedRoles={SUPERADMIN_ONLY_ROLES}>
              <EmailCapture />
            </ProtectedRoute>
          }
        />
        <Route
          path="/whatsapp-bulk-send"
          element={
            <ProtectedRoute allowedRoles={ROLES_WITH_WHATSAPP_ACCESS}>
              <WhatsappBulkSend />
            </ProtectedRoute>
          }
        />
        <Route
          path="/whatsapp-campaigns"
          element={
            <ProtectedRoute allowedRoles={ROLES_WITH_WHATSAPP_ACCESS}>
              <WhatsappCampaigns />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute allowedRoles={SUPERADMIN_ONLY_ROLES}>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<HomeRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
